/**
 * EliorGroup.Joyfood.B2B2C API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export type BusinessModelTypes = null | null | null;

export const BusinessModelTypes = {
    NUMBER_null: null as BusinessModelTypes,
    NUMBER_null2: null as BusinessModelTypes,
    NUMBER_null3: null as BusinessModelTypes
};

